import { useRouteError } from "react-router-dom";

export default function ErrorPage() {
  // useRouteError provides the error that was thrown. When the user navigates to routes that don't exist you'll get an error response with a "Not Found" statusText.
  const error: any = useRouteError();
  console.error(error);

  return (
    <div id="error-page">
      <h1>Oops!</h1>
      <p>Sorry, an unexpected error has occurred.</p>
      <p>
        {error.statusText || error.message ? (
          <i>{error.statusText || error.message}</i>
        ) : null}
      </p>
    </div>
  );
}
